import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { AutocompleteInput } from 'shouldve-been-mui';

class InspectorChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.INSPECTOR);
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, inspectorAutocompleteOptions: { label: string, id: string, disabled: boolean }[], screenWidth: number): JSX.Element {

        const currentInspectorAutocompleteOptions: { label: string, id: string, disabled: boolean }[] = inspectorAutocompleteOptions;

        if (value !== '' && !inspectorAutocompleteOptions.map((option: { label: string, id: string, disabled: boolean }) => option.id).includes(value)) { //allows removed options to still be there until changed
            currentInspectorAutocompleteOptions.push({
                label: value,
                id: value,
                disabled: true,
            });
        }

        return (
            <React.Fragment key={this.elementId}>
                <AutocompleteInput
                    labelText={this.name}
                    value={value}
                    options={currentInspectorAutocompleteOptions}
                    onChange={onChange}
                    width={Math.min(screenWidth * 0.8, 500)}
                    dense={true}
                    limit={1000}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default InspectorChecklistElement;